import { Alert } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectModalSuccessMessage } from './phasesSlice';

export const PhaseModalMessageBanner = () => {
  const modalErrorMessage = useSelector(
    (state) => state.phases.modalErrorMessage
  );
  const modalSuccessMessage = useSelector(selectModalSuccessMessage);
  const alertVariant = modalErrorMessage ? 'error' : 'success';
  const message = modalErrorMessage || modalSuccessMessage;

  return message ? (
    <Alert
      severity={alertVariant}
    >
      {message}
    </Alert>
  ) : null;
};
